export default "__VITE_ASSET__bf05cdfe__"